// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--1YHJC","body":"layout-module--body--8QQfr"};